var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompraServicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffeb99;}.cls-2{fill:#999;}.cls-3{fill:#fff;}.cls-4{fill:#ddd;}.cls-5{fill:#abe5ff;}.cls-6{fill:#fffbee;}.cls-7{fill:#eab67d;}.cls-8{fill:#d7f5ff;}.cls-9{fill:#7cc8dd;}.cls-10{fill:#4d4d4d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smartphone credit card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469,166.36H269.87V345.64H469a15.8,15.8,0,0,0,15.8-15.8V182.16A15.8,15.8,0,0,0,469,166.36Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269.87,
    y: 206.33,
    width: 214.89,
    height: 39.76
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.24,
    y: 50.27,
    width: 217.5,
    height: 411.47,
    rx: 30.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.13,461.73a30.61,30.61,0,0,0,30.61-30.61V137.41a26.52,26.52,0,0,0-23.08,26.29V412.64a26.07,26.07,0,0,1-26.07,26.06H94.21a21,21,0,0,0-21,21v2.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.13,50.27H57.86A30.61,30.61,0,0,0,27.24,80.88v27h217.5v-27A30.61,30.61,0,0,0,214.13,50.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.86,461.73H214.13a30.61,30.61,0,0,0,30.61-30.61v-27H27.24v27A30.61,30.61,0,0,0,57.86,461.73Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 136.76,
    cy: 256,
    r: 63.52
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M469,166.36H388.33v8.74a15.44,15.44,0,0,0,15.44,15.44h81v-8.38A15.8,15.8,0,0,0,469,166.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M426.49,322.87H269.87v22.77H441.8v-7.45A15.32,15.32,0,0,0,426.49,322.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M89.62,76.47a20.86,20.86,0,0,0,20.86-20.86V50.27H61.63a33.92,33.92,0,0,0-33,26.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M214.13,461.73a30.61,30.61,0,0,0,30.61-30.61v-27H221.66v8.51a26.07,26.07,0,0,1-26.07,26.06H94.21a21,21,0,0,0-21,21v2.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M469,160.65H275.58a5.71,5.71,0,1,0,0,11.42H469a10.1,10.1,0,0,1,10.09,10.09v2.67a5.71,5.71,0,0,0,11.42,0v-2.67A21.54,21.54,0,0,0,469,160.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M484.76,200.62H275.58a5.71,5.71,0,1,0,0,11.42H479.05v28.34H275.58a5.71,5.71,0,1,0,0,11.42H479.05v78A10.1,10.1,0,0,1,469,339.93H275.58a5.71,5.71,0,1,0,0,11.42H469a21.54,21.54,0,0,0,21.51-21.51V206.33A5.71,5.71,0,0,0,484.76,200.62Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.58,281.42h60.59a5.71,5.71,0,1,0,0-11.41H275.58a5.71,5.71,0,1,0,0,11.41Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M355.12,278.88a6,6,0,0,0,.71.87,5.72,5.72,0,0,0,8.08,0,5.34,5.34,0,0,0,.7-.87,6.18,6.18,0,0,0,.53-1,5.51,5.51,0,0,0,.32-1.07,5.24,5.24,0,0,0,.12-1.11,5.7,5.7,0,0,0-6.82-5.6,4.89,4.89,0,0,0-1.07.32,7.17,7.17,0,0,0-1,.52,6.79,6.79,0,0,0-.87.72,5.71,5.71,0,0,0-1.67,4,5.24,5.24,0,0,0,.12,1.11,5.51,5.51,0,0,0,.32,1.07A7.06,7.06,0,0,0,355.12,278.88Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M380.45,281a5.66,5.66,0,0,0,1.06.33,5.76,5.76,0,0,0,2.24,0,6.55,6.55,0,0,0,1.07-.33,4.9,4.9,0,0,0,1-.53,5.72,5.72,0,0,0,.86-.7,4.91,4.91,0,0,0,.71-.87,6.18,6.18,0,0,0,.53-1,7.39,7.39,0,0,0,.33-1.07,6,6,0,0,0,.1-1.11,5.67,5.67,0,0,0-7.88-5.27,5,5,0,0,0-1,.51,6.26,6.26,0,0,0-.88.72,5.73,5.73,0,0,0,0,8.07,5,5,0,0,0,.88.7A4.2,4.2,0,0,0,380.45,281Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M409.48,279.75a5.72,5.72,0,0,0,1.67-4,4.63,4.63,0,0,0-.12-1.12,5.49,5.49,0,0,0-.31-1.07,5.78,5.78,0,0,0-.53-1,4.65,4.65,0,0,0-.71-.87,5.7,5.7,0,0,0-8.06,0,4,4,0,0,0-.72.87,5.78,5.78,0,0,0-.53,1,6.33,6.33,0,0,0-.33,1.07,5.91,5.91,0,0,0-.11,1.12,5.71,5.71,0,0,0,9.75,4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M57.86,467.44H214.12a36.36,36.36,0,0,0,36.33-36.32V80.88a36.36,36.36,0,0,0-36.33-36.32H57.86A36.37,36.37,0,0,0,21.53,80.88V431.12A36.37,36.37,0,0,0,57.86,467.44ZM214.12,456H57.86A24.94,24.94,0,0,1,33,431.12V409.84H239v21.28A24.94,24.94,0,0,1,214.12,456ZM57.86,56H214.12A24.94,24.94,0,0,1,239,80.88V398.42H33V113.58H221.56a5.71,5.71,0,1,0,0-11.42H33V80.88A24.94,24.94,0,0,1,57.86,56Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M113.69,84.77h44.6a5.71,5.71,0,1,0,0-11.41h-44.6a5.71,5.71,0,1,0,0,11.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.29,426.89h-44.6a5.71,5.71,0,1,0,0,11.42h44.6a5.71,5.71,0,0,0,0-11.42Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M179.68,83.81a5.42,5.42,0,0,0,1,.52,5.28,5.28,0,0,0,1.07.33,6,6,0,0,0,1.12.12,5.89,5.89,0,0,0,1.11-.12,4.92,4.92,0,0,0,1.07-.33,5.11,5.11,0,0,0,1-.52,5,5,0,0,0,.87-.7,7.56,7.56,0,0,0,.72-.87,7.86,7.86,0,0,0,.53-1,5.7,5.7,0,0,0,.31-1.07,5.66,5.66,0,0,0,0-2.22,5.58,5.58,0,0,0-.31-1.08,6.58,6.58,0,0,0-.53-1,6.79,6.79,0,0,0-.72-.87,5.08,5.08,0,0,0-.87-.71,6.58,6.58,0,0,0-1-.53,5.51,5.51,0,0,0-1.07-.32A5.72,5.72,0,0,0,178.81,75a5.34,5.34,0,0,0-.7.87,4.65,4.65,0,0,0-.53,1,5.63,5.63,0,0,0-.33,1.08,5.69,5.69,0,0,0,1.57,5.15A5.36,5.36,0,0,0,179.68,83.81Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.85,301.94a57.23,57.23,0,0,1-35.09,11.87,57.87,57.87,0,0,1-54-78.52,5.7,5.7,0,0,0-10.65-4.09A69.24,69.24,0,0,0,178.79,311a5.71,5.71,0,0,0-6.94-9.07Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.76,186.77a5.71,5.71,0,1,0,0,11.42A57.88,57.88,0,0,1,194.57,256,5.71,5.71,0,1,0,206,256,69.31,69.31,0,0,0,136.76,186.77Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M98.58,210.94a5.71,5.71,0,0,0,3.43-1.15c.69-.52,1.39-1,2.1-1.51a5.71,5.71,0,0,0-6.46-9.41c-.85.58-1.68,1.18-2.5,1.8a5.71,5.71,0,0,0,3.43,10.27Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.47,261.71H140A5.67,5.67,0,1,1,140,273H127.29a5.71,5.71,0,0,0,0,11.42h3.76v3a5.71,5.71,0,0,0,11.42,0v-3.19a17.08,17.08,0,0,0-2.43-34h-6.57a5.67,5.67,0,1,1,0-11.33h12.75a5.71,5.71,0,0,0,0-11.42h-3.75v-3a5.71,5.71,0,0,0-11.42,0v3.19a17.08,17.08,0,0,0,2.42,34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompraServicio);
export default __webpack_public_path__ + "static/media/compra_servicio.45958e92e94edea7592d35f38b9a0720.svg";
export { ForwardRef as ReactComponent };